import script from "./chose-coupon.vue?vue&type=script&setup=true&lang=js"
export * from "./chose-coupon.vue?vue&type=script&setup=true&lang=js"

import "./chose-coupon.vue?vue&type=style&index=0&id=6c4e03e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4e03e0"]])

export default __exports__